import React from 'react'
import PropTypes from 'prop-types'
import {Heading} from '@salesforce/retail-react-app/app/components/shared/ui'

const Title = ({title, color, tag, titleSizeMobile, titleSizeDesktop, titleFontFamily}) => {
    return (
        <Heading
            as={tag}
            marginTop="20px"
            fontSize={{base: titleSizeMobile, md: titleSizeDesktop}}
            fontFamily={titleFontFamily || 'heading'}
            fontWeight="400"
            lineHeight="normal"
            color={color}
        >
            {title}
        </Heading>
    )
}

Title.propTypes = {
    title: PropTypes.string,
    color: PropTypes.string,
    tag: PropTypes.string,
    titleSizeMobile: PropTypes.string,
    titleSizeDesktop: PropTypes.string,
    titleFontFamily: PropTypes.string
}

export default Title
